export default "__VITE_ASSET__ebd4828a__"